<template>
  <div style="padding: 20px">
    <v-card>
      <v-toolbar class="indigo white--text" dense primary-title>
        <v-toolbar-title>Picking</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              small
              elevation="1"
              @click="$router.push({ name: 'AddPickingView' })"
            >
              <v-icon color="#1a80b6"> mdi-plus </v-icon>
            </v-btn>
          </template>
          <span>Crea Picking</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              small
              elevation="1"
              class="ml-10"
              @click="$router.push({ name: 'PickingSegnalazioni' })"
            >
              <v-icon color="error"> mdi-alert </v-icon>
            </v-btn>
          </template>
          <span>Segnalazioni</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              small
              elevation="1"
              class="ml-10"
              @click="impostazioniDialog = true"
            >
              <v-icon color="primary"> mdi-magnify </v-icon>
            </v-btn>
          </template>
          <span>Impostazioni</span>
        </v-tooltip>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              small
              elevation="1"
              class="ml-10"
              @click="toggleFilters"
            >
              <v-icon color="purple"> mdi-filter </v-icon>
            </v-btn>
          </template>
          <span>Filtri</span>
        </v-tooltip>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" small elevation="1" @click="gotoDashboard">
              <v-icon class="error--text"> mdi-keyboard-backspace </v-icon>
            </v-btn>
          </template>
          <span>Vai alla Dashboard</span>
        </v-tooltip>
      </v-toolbar>
      <v-progress-linear
        indeterminate
        color="cyan"
        v-if="loading"
        id="progress"
      >
      </v-progress-linear>

      <v-card-text>
        <v-row v-if="show_filters" dense>
          <v-col cols="12">
            <v-row dense>
              <v-col class="flex-grow-1 flex-shrink-0">
                <v-autocomplete
                  clearable
                  label="Codice picking"
                  :items="pCodici"
                  dense
                  outlined
                  v-model="filtro_picking"
                  @change="changeFilters"
                >
                </v-autocomplete>
              </v-col>

              <v-col class="flex-grow-1 flex-shrink-0">
                <v-autocomplete
                  clearable
                  label="Codice ordine"
                  :items="oCodici"
                  dense
                  outlined
                  v-model="filtro_ordine"
                  @change="changeFilters"
                >
                </v-autocomplete>
              </v-col>

              <v-col>
                <v-menu
                  ref="menu-da"
                  v-model="menu_da"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      append-icon="mdi-close"
                      @click:append="clearStart"
                      dense
                      v-model="data_start_formatted"
                      label="Da"
                      autocomplete="off"
                      persistent-hint
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      @change="changeDate"
                    >
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="data_start"
                    no-title
                    locale="it"
                    @input="changeDate"
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col>
                <v-menu
                  ref="menu-a"
                  v-model="menu_a"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      append-icon="mdi-close"
                      @click:append="clearEnd"
                      dense
                      v-model="data_end_formatted"
                      label="A"
                      autocomplete="off"
                      persistent-hint
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      @change="changeDate"
                    >
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="data_end"
                    no-title
                    locale="it"
                    @input="changeDate"
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>

              <v-col>
                <v-select
                  label="Stato Lavorazione"
                  dense
                  outlined
                  hide-details
                  v-model="filtro_stato"
                  :items="stati"
                  item-text="text"
                  @change="changeFilters"
                  return-object
                >
                </v-select>
              </v-col>

              <v-col>
                <v-autocomplete
                  clearable
                  label="Operatore"
                  dense
                  outlined
                  hide-details
                  v-model="filtro_operatore"
                  :items="operatori"
                  @change="changeFilters"
                >
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col class="flex-grow-1 flex-shrink-0">
                <v-select
                  label="Stato Prelievo"
                  :items="filtriG"
                  dense
                  outlined
                  v-model="filtro_giac"
                  @change="changeFilters"
                  item-text="text"
                  return-object
                >
                </v-select>
              </v-col>
              <v-col class="flex-grow-1 flex-shrink-0">
                <v-select
                  label="Stato Magazzino"
                  :items="filtriM"
                  dense
                  outlined
                  v-model="filtro_mag"
                  @change="changeFilters"
                  item-text="text"
                  return-object
                >
                </v-select>
              </v-col>
              <v-col class="flex-grow-1 flex-shrink-0">
                <v-select
                  label="Urgenza"
                  :items="filtriU"
                  dense
                  outlined
                  v-model="filtro_urg"
                  @change="changeFilters"
                  item-text="desc"
                  item-value="id"
                >
                </v-select>
              </v-col>
              <v-col class="flex-grow-1 flex-shrink-0">
                <v-select
                  :items="codiciDocumento"
                  v-model="selectedCod"
                  @change="getPicking"
                  outlined
                  dense
                  label="Tipo Picking"
                  item-text="text"
                  item-value="value"
                >
                </v-select>
              </v-col>
              <v-col class="flex-grow-1 flex-shrink-0">
                <v-autocomplete
                  clearable
                  label="Ragione Sociale"
                  :items="ragioni_sociali"
                  dense
                  outlined
                  v-model="filtro_rag_soc"
                  @change="changeFilters"
                  item-text="desc"
                  item-value="id"
                >
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-data-table
              :page.sync="pageNumber"
              :headers="headers"
              :items="show_filters ? filtered : pickings"
              :key="dtKey"
              :sort-by.sync="pickingSortArr"
              :sort-desc="[true, false]"
              multi-sort
            >
              <template v-slot:[`item.urgenza`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      small
                      elevation="1"
                      class="ma-1"
                      @click="changeUrgenza(item)"
                    >
                      <v-icon v-on="on" :color="urgenze[item.urgenza].color">
                        {{ urgenze[item.urgenza].icon }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ urgenze[item.urgenza].desc }}</span>
                </v-tooltip>
              </template>

              <template v-slot:[`item.data_documento`]="{ item }">
                {{ item?.data_documento?.slice(2) }}
              </template>

              <template v-slot:[`item.stato_mag`]="{ item }">
                <v-tooltip bottom v-if="item.stato_mag != 0">
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-on="on"
                      :color="
                        item.stato_mag == 1 ? 'yellow accent-4' : 'success'
                      "
                    >
                      {{
                        item.stato_mag == 1 ? "mdi-alpha-p-circle" : "mdi-check"
                      }}
                    </v-icon>
                  </template>
                  <span>{{
                    item.stato_mag == 1
                      ? "Parzialmente disponibile"
                      : "Completamente disponibile"
                  }}</span>
                </v-tooltip>
                <v-tooltip bottom v-else>
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on"> mdi-cancel </v-icon>
                  </template>
                  <span>Articolo non in Magazzino</span>
                </v-tooltip>
              </template>

              <template v-slot:[`item.dettaglio`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      small
                      elevation="1"
                      class="mr-3"
                      @click="clickModificaOrdine(item)"
                    >
                      <v-icon color="#1a80b6"> mdi-eye </v-icon>
                    </v-btn>
                  </template>
                  <span>Dettaglio Ordine</span>
                </v-tooltip>
              </template>
              <template v-slot:[`item.stato_doc`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      :color="statusIcons[item?.stato_doc]?.color"
                      v-on="on"
                    >
                      {{ statusIcons[item?.stato_doc]?.icon }}
                    </v-icon>
                  </template>
                  <span>{{ statusIcons[item?.stato_doc]?.descrizione }}</span>
                </v-tooltip>
              </template>
              <template v-slot:[`item.stato_giacenza`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      :color="statusIconsG[item?.stato_giacenza]?.color"
                      v-on="on"
                    >
                      {{ statusIconsG[item?.stato_giacenza]?.icon }}
                    </v-icon>
                  </template>
                  <span>{{ statusIconsG[item?.stato_giacenza]?.desc }}</span>
                </v-tooltip>
              </template>
              <!-- <template v-slot:[`item.avvio`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      small
                      elevation="1"
                      color="success"
                      @click="avviaPicking(item)"
                    >
                      <v-icon>
                        mdi-play
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Inizia</span>
                </v-tooltip>
              </template>-->

              <template v-slot:[`item.delete`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      small
                      elevation="1"
                      @click="showDeletePicking(item)"
                    >
                      <v-icon class="error--text">mdi-close</v-icon>
                    </v-btn>
                  </template>
                  <span>Elimina</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-dialog v-model="impostazioniDialog" width="600">
      <v-card>
        <v-toolbar class="indigo white--text" dense>
          <v-toolbar-title class="white--text">
            Impostazioni Picking</v-toolbar-title
          >
          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" @click="saveImpostazioni" small>
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" @click="impostazioniDialog = false" small>
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>

        <v-col cols="12">
          <v-row>
            <v-col cols="6">
              <v-select
                :items="magazzini"
                label="Magazzino Default"
                v-model="magazzinoDefault"
                item-text="des_magazzino"
                item-value="id_magazzino"
              >
              </v-select>
            </v-col>
            <v-col cols="6">
              <v-text-field
                type="number"
                label="% Materiale"
                v-model="percentMaterial"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogCausali" width="400">
      <v-card>
        <v-toolbar class="indigo white--text" dense>
          <v-toolbar-title> Causali Cambia Urgenza </v-toolbar-title>
          <v-spacer />
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" small elevation="1" @click="saveCausali">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-spacer />
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                small
                elevation="1"
                @click="dialogCausali = false"
              >
                <v-icon color="error"> mdi-keyboard-backspace </v-icon>
              </v-btn>
            </template>
            <span>Indietro</span>
          </v-tooltip>
        </v-toolbar>
        <v-progress-linear
          indeterminate
          color="cyan"
          v-if="loading"
          id="progress"
        >
        </v-progress-linear>
        <v-col>
          <v-row>
            <v-col cols="12">
              <v-btn small @click="addCausale">
                <v-icon color="primary" class="ma-1">mdi-plus</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row v-for="(item, i) in causaliUrgenza" :key="i">
            <v-col cols="10">
              <v-text-field
                v-model="tempCausale"
                v-if="editCausale && i == causaliUrgenza.length - 1"
              >
              </v-text-field>
              <h3 v-else>
                {{ item }}
              </h3>
            </v-col>
            <v-col cols="2">
              <v-tooltip
                bottom
                v-if="editCausale && i == causaliUrgenza.length - 1"
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    small
                    elevation="1"
                    @click="confirmNewCausale"
                  >
                    <v-icon color="success">mdi-check</v-icon>
                  </v-btn>
                </template>
                <span>Salva</span>
              </v-tooltip>
              <v-tooltip bottom v-else>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    small
                    elevation="1"
                    @click="deleteCausale(i)"
                  >
                    <v-icon class="error--text">mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Elimina</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-col>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogViewUrg" width="800">
      <v-card>
        <v-toolbar class="indigo white--text" dense>
          <v-toolbar-title class="white--text"
            >Cambiamenti Urgenza</v-toolbar-title
          >
          <v-spacer />
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                small
                elevation="1"
                @click="dialogViewUrg = false"
              >
                <v-icon color="error"> mdi-keyboard-backspace </v-icon>
              </v-btn>
            </template>
            <span>Indietro</span>
          </v-tooltip>
        </v-toolbar>
        <v-progress-linear
          indeterminate
          color="cyan"
          v-if="loading"
          id="progress"
        >
        </v-progress-linear>
        <v-data-table :items="cambiamentiUrgenza" :headers="urgenzaHeaders">
          <template v-slot:[`item.nome`]="{ item }">
            {{ item.nome + " " + item.cognome }}
          </template>
          <template v-slot:[`item.causale`]="{ item }">
            {{ causaliUrgenza[item.causale] }}
          </template>
          <template v-slot:[`item.urgenza`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" :color="urgenze[item.urgenza].color">
                  {{ urgenze[item.urgenza].icon }}
                </v-icon>
              </template>
              <span>{{ urgenze[item.urgenza].desc }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogChngUrg" width="600">
      <v-card>
        <v-toolbar class="indigo white--text" dense>
          <v-toolbar-title class="white--text">Urgenza</v-toolbar-title>
          <v-spacer />
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" small elevation="1" @click="saveUrgenza">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-spacer />
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                small
                elevation="1"
                @click="viewUrgenza(editUrgItem)"
              >
                <v-icon color="primary"> mdi-eye </v-icon>
              </v-btn>
            </template>
            <span>Visualizza Cambiamenti Urgenza</span>
          </v-tooltip>
          <v-spacer />
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                small
                elevation="1"
                @click="dialogChngUrg = false"
              >
                <v-icon color="error"> mdi-keyboard-backspace </v-icon>
              </v-btn>
            </template>
            <span>Indietro</span>
          </v-tooltip>
        </v-toolbar>
        <v-progress-linear
          indeterminate
          color="cyan"
          v-if="loading"
          id="progress"
        >
        </v-progress-linear>
        <v-col :key="keyCausale">
          <v-select
            label="Urgenza"
            :items="urgenze"
            item-text="desc"
            return-object
            v-model="selectedUrgenza"
            class="ma-1"
          >
          </v-select>
          <v-select
            label="Causale"
            class="ma-1"
            :items="causaliUrgenza"
            v-model="selectedCausale"
          >
            <template v-slot:append-outer>
              <v-icon color="primary" @click="editCausali"> mdi-eye </v-icon>
            </template>
          </v-select>
          <v-textarea label="Note" class="ma-1" v-model="noteUrgenza">
          </v-textarea>
        </v-col>
      </v-card>
    </v-dialog>

    <v-dialog
      content-class="artDialog"
      persistent
      v-model="dialogEliminaPicking"
      width="unset"
    >
      <v-card>
        <v-toolbar dense class="indigo darken-1 headline">
          <v-toolbar-title class="white--text"> Eliminazione </v-toolbar-title>
        </v-toolbar>

        <v-card-text class="mt-6">
          <h3 style="text-align: left !important">
            Sei sicuro di voler eliminare questa picking?
          </h3>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" dark @click="dialogEliminaPicking = false">
            ANNULLA
          </v-btn>
          <v-btn color="#4caf50" dark @click="deletePicking"> CONFERMA </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <SnackbarQV ref="SnackbarQV" />
  </div>
</template>

<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "ListPicking",
  components: {
    SnackbarQV,
  },
  data() {
    return {
      pageNumber: 1,
      magazzinoDefault: null,
      percentMaterial: null,
      impostazioniDialog: false,
      selectedCod: "ORDC",
      editCausale: false,
      dialogCausali: false,
      editUrgId: null,
      dialogChngUrg: false,
      dialogViewUrg: false,
      show_filters: false,
      menu_a: false,
      menu_da: false,
      loading: false,
      codice_picking: null,
      codice_ordine: null,
      data_start: null,
      data_end: null,
      data_start_formatted: null,
      data_end_formatted: null,
      operatore: null,
      stato: null,
      dialogEliminaPicking: false,
      filtro_picking: "Tutti",
      filtro_operatore: "Tutti",
      filtro_ordine: "Tutti",
      filtro_rag_soc: "Tutti",
      tempCausale: "",
      magazzini: [],
      cambiamentiUrgenza: [],
      causaliUrgenza: [],
      keyCausale: 0,
      dtKey: 0,
      editUrgItem: null,
      noteUrgenza: "",
      selectedUrgenza: {},
      selectedCausale: "",
      pickingSortArr: ["urgenza", "data_documento"],
      codiciDocumento: [
        {
          text: "Conto Lavoro",
          value: "ORDC",
        },
        {
          text: "Produzione",
          value: "ORDP",
        },
        {
          text: "Placing",
          value: "PLCG",
        },
      ],
      filtriG: [
        {
          text: "Tutti",
          value: -1,
        },
        {
          text: "Non prelevato",
          value: 0,
        },
        {
          text: "Parzialmente prelevato",
          value: 1,
        },
        {
          text: "Completamente prelevato",
          value: 2,
        },
      ],
      filtriM: [
        {
          text: "Tutti",
          value: -1,
        },
        {
          text: "Non disponibile",
          value: 0,
        },
        {
          text: "Parzialmente disponibile",
          value: 1,
        },
        {
          text: "Completamente disponibile",
          value: 2,
        },
      ],
      filtro_urg: -1,
      filtro_mag: {
        text: "Tutti",
        value: -1,
      },
      filtro_giac: {
        text: "Tutti",
        value: -1,
      },
      filtro_stato: {
        text: "Tutti",
        vals: [],
      },
      pCodici: [],
      oCodici: [],
      operatori: ["Tutti"],
      filtered: [],
      stati: [
        {
          text: "Tutti",
          vals: [],
        },
        {
          text: "Nuovo",
          vals: [0],
        },
        {
          text: "In Lavorazione",
          vals: [1, 2],
        },
        {
          text: "Completato",
          vals: [3],
        },
      ],
      statusIcons: [
        {
          color: "primary",
          icon: "mdi-tag",
          descrizione: "Nuovo",
        },
        {
          color: "yellow accent-4",
          icon: "mdi-timer-sand-full",
          descrizione: "In Lavorazione",
        },
        {
          color: "yellow accent-4",
          icon: "mdi-timer-sand-full",
          descrizione: "In Lavorazione",
        },
        {
          color: "success",
          icon: "mdi-check",
          descrizione: "Completato",
        },
      ],
      statusIconsG: [
        {
          color: "error",
          icon: "mdi-cancel",
          desc: "Quantità non sufficiente",
        },
        {
          color: "yellow accent-4",
          icon: "mdi-alpha-p-circle",
          desc: "Parzialmente prelevato",
        },
        {
          color: "success",
          icon: "mdi-check",
          desc: "Completatmente prelevato",
        },
      ],
      ragioni_sociali: [],
      filtriU: [
        {
          id: -1,
          desc: "Tutti",
        },
        {
          id: 0,
          desc: "Bassa",
        },
        {
          id: 1,
          desc: "Media",
        },
        {
          id: 2,
          desc: "Alta",
        },
      ],
      urgenze: [
        {
          id: 0,
          icon: "mdi-arrow-down",
          color: "success",
          desc: "Bassa",
        },
        {
          id: 1,
          icon: "mdi-minus",
          color: "yellow accent-4",
          desc: "Media",
        },
        {
          id: 2,
          icon: "mdi-exclamation-thick",
          color: "error",
          desc: "Alta",
        },
      ],
      headers: [],
      headers_default: [
        {
          text: "Dettaglio",
          value: "dettaglio",
          sortable: false,
        },
        {
          text: "Urgenza",
          value: "urgenza",
        },
        {
          text: "Picking",
          value: "num_protocollo",
        },
        {
          text: "Numero Righe",
          value: "num_righe",
        },
        {
          text: "Data",
          value: "data_documento",
        },
        {
          text: "Ordine",
          value: "num_documento",
        },
        {
          text: "Rag. Soc.",
          value: "ragione_sociale",
        },
        {
          text: "Operatore",
          value: "nom_utente",
        },
        {
          text: "Colore",
          value: "note",
        },
        {
          text: "Fornitore",
          value: "lavorista",
        },
        {
          text: "Lavorazione",
          value: "stato_doc",
        },
        {
          text: "Prelievo",
          value: "stato_giacenza",
        },
        {
          text: "Magazzino",
          value: "stato_mag",
        },
      ],
      headers_placing: [
        {
          text: "Dettaglio",
          value: "dettaglio",
          sortable: false,
        },
        {
          text: "Urgenza",
          value: "urgenza",
        },
        {
          text: "Picking",
          value: "num_protocollo",
        },
        {
          text: "Data",
          value: "data_documento",
        },
        {
          text: "Ordine",
          value: "num_documento",
        },
        {
          text: "Rag. Soc.",
          value: "ragione_sociale",
        },
        {
          text: "Operatore",
          value: "nom_utente",
        },
        {
          text: "Colore",
          value: "note",
        },
        {
          text: "Fornitore",
          value: "lavorista",
        },
        {
          text: "Lavorazione",
          value: "stato_doc",
        },
      ],
      urgenzaHeaders: [
        {
          text: "Urgenza",
          value: "urgenza",
        },
        {
          text: "Utente",
          value: "nome",
        },
        {
          text: "Data",
          value: "data",
        },
        {
          text: "Causale",
          value: "causale",
        },
        {
          text: "Note",
          value: "note",
        },
      ],
      pickings: [],
    };
  },
  mounted() {
    this.callList();
  },
  methods: {
    async getImpostazioni() {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getimpostazionipicking",
          token: localStorage.getItem("user_token"),
        },
      };
      await this.$store.dispatch("api", request).then((res) => {
        if (
          res.data.result.impostazioni.length > 0 &&
          res.data.result.impostazioni[0].note != null
        ) {
          var tempImpo = res.data.result.impostazioni[0].note;
          this.magazzinoDefault = parseInt(tempImpo.split(",")[0]);
          this.percentMaterial = parseInt(tempImpo.split(",")[1]);
        }
      });
    },
    saveImpostazioni() {
      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setimpostazionipicking",
          impostazioni: this.magazzinoDefault + "," + this.percentMaterial,
          token: localStorage.getItem("user_token"),
        },
      };
      this.$store.dispatch("api", request).then((res) => {
        if (res.data.statusCode == 200) {
          this.$refs.SnackbarQV.print("success", "Impostazioni Salvati");
        } else {
          this.$refs.SnackbarQV.print("error", "Impostazioni non Salvati");
        }
        this.impostazioniDialog = false;
      });
    },
    async getMagazzini() {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getmagazzini",
          token: localStorage.user_token,
        },
      };
      await this.$store.dispatch("api", request).then((res) => {
        this.magazzini = Array.from(res.data);
      });
    },
    clickModificaOrdine(arg) {
      localStorage.setItem("picking_page", this.pageNumber.toString());
      localStorage.setItem("picking_filter_urgenza", this.filtro_urg);
      localStorage.setItem(
        "picking_filter_statoMag",
        JSON.stringify(this.filtro_mag)
      );
      localStorage.setItem(
        "picking_filter_statoGiac",
        JSON.stringify(this.filtro_giac)
      );
      localStorage.setItem("picking_selected_codice", this.selectedCod);

      localStorage.setItem("picking_sort", JSON.stringify(this.pickingSortArr));
      localStorage.setItem("picking_filter_show", this.show_filters);
      localStorage.setItem(
        "picking_filter_state",
        JSON.stringify(this.filtro_stato)
      );
      localStorage.setItem("picking_filter_picking", this.filtro_picking);
      localStorage.setItem("picking_filter_operator", this.filtro_operatore);
      localStorage.setItem("picking_filter_order", this.filtro_ordine);
      localStorage.setItem(
        "picking_filter_date_start",
        this.data_start_formatted
      );
      localStorage.setItem("picking_filter_date_end", this.data_end_formatted);
      this.$router.push({
        name: "PickingView",
        params: {
          id_documento: arg.id_documento,
          num_documento: arg.num_documento,
        },
      });
    },
    editCausali() {
      this.dialogCausali = true;
    },
    async changeUrgenza(item) {
      this.selectedUrgenza = this.urgenze[item.urgenza];

      this.loading = true;

      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "geturgenze",
          token: localStorage.user_token,
          id_documento: -1,
        },
      };

      await this.$store.dispatch("api", request).then((res) => {
        if (
          res.data.result.urgenze != null &&
          res.data.result.urgenze.length > 0 &&
          res.data.result.urgenze[0].note != null &&
          res.data.result.urgenze[0].note != ""
        ) {
          this.causaliUrgenza = res.data.result.urgenze[0].note.split(",");
        } else {
          this.causaliUrgenza = [];
        }
      });

      this.loading = false;

      this.editUrgId = item.id_documento;
      this.editUrgItem = item;
      this.dialogChngUrg = true;
    },
    async saveUrgenza() {
      this.loading = true;

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "seturgenza",
          urgenza: this.selectedUrgenza.id,
          id_documento: this.editUrgId,
          note: this.noteUrgenza,
          causale: this.causaliUrgenza.indexOf(this.selectedCausale),
          token: localStorage.user_token,
        },
      };

      await this.$store.dispatch("api", request).then((res) => {
        if (res.data.response) {
          this.$refs.SnackbarQV.print("success", "Urgenza salvata");
        } else {
          this.$refs.SnackbarQV.print("error", "Urgenza non salvata");
        }
      });

      this.loading = false;
      this.dialogChngUrg = false;
      this.noteUrgenza = "";
      this.selectedCausale = "";
      this.editUrgItem.urgenza = this.selectedUrgenza.id;
      this.dtKey += 1;
    },
    async viewUrgenza(item) {
      this.loading = true;

      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "geturgenze",
          token: localStorage.user_token,
          id_documento: -1,
        },
      };

      await this.$store.dispatch("api", request).then((res) => {
        this.causaliUrgenza = res.data.result.urgenze[0].note.split(",");
      });

      const request2 = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "geturgenze",
          id_documento: item.id_documento,
          token: localStorage.user_token,
        },
      };

      this.$store.dispatch("api", request2).then((res) => {
        if (res.data.response) {
          console.log(this.causaliUrgenza);
          this.cambiamentiUrgenza = Array.from(res.data.result.urgenze);
          console.log(this.cambiamentiUrgenza);
          this.dialogViewUrg = true;
        } else {
          this.$refs.SnackbarQV.print("error", "Errore caricamento dati");
        }
        this.loading = false;
      });
    },
    addCausale() {
      this.causaliUrgenza.push("");
      this.editCausale = true;
    },
    async confirmNewCausale() {
      this.causaliUrgenza[this.causaliUrgenza.length - 1] = this.tempCausale;
      this.editCausale = false;
      this.keyCausale += 1;
    },
    async saveCausali() {
      this.loading = true;

      var tempCausali = "";
      this.causaliUrgenza.forEach((e) => {
        tempCausali += e + ",";
      });
      tempCausali = tempCausali.slice(0, tempCausali.length - 1);

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "seturgenze",
          urgenze: tempCausali,
          token: localStorage.user_token,
        },
      };

      await this.$store.dispatch("api", request).then((res) => {
        if (res.data.response) {
          this.$refs.SnackbarQV.print("success", "Causali salvati");
        } else {
          this.$refs.SnackbarQV.print("error", "Causali non salvati");
        }
      });

      this.loading = false;
      this.dialogCausali = false;
    },
    deleteCausale(i) {
      this.causaliUrgenza.splice(i, 1);
    },
    gotoDashboard() {
      localStorage.setItem("picking_filter_urgenza", "null");
      localStorage.setItem("picking_filter_statoMag", "null");
      localStorage.setItem("picking_filter_statoGiac", "null");
      localStorage.setItem("picking_selected_codice", "null");
      localStorage.setItem("picking_sort", "null");
      localStorage.setItem("picking_filter_show", "null");
      localStorage.setItem("picking_filter_state", "null");
      localStorage.setItem("picking_filter_picking", "null");
      localStorage.setItem("picking_filter_operator", "null");
      localStorage.setItem("picking_filter_order", "null");
      localStorage.setItem("picking_filter_date_start", "null");
      localStorage.setItem("picking_filter_date_end", "null");
      this.$router.push("/home/production");
    },
    async getPicking() {
      this.loading = true;

      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getdocumento",
          token: localStorage.user_token,
          id_documento: "",
          cod_documento: this.selectedCod,
        },
      };

      await this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.pickings = new Array();
            this.pickings = Array.from(res.data.documento);
            for (let i = 0; i < this.pickings.length; i++) {
              const p = this.pickings[i];
              if (
                p.urgenza == null ||
                p.urgenza < 0 ||
                p.urgenza >= this.urgenze.length
              ) {
                p.urgenza = 0;
              }
              p.data_documento =
                p.data_documento.split("/")[2] +
                "-" +
                p.data_documento.split("/")[1] +
                "-" +
                p.data_documento.split("/")[0];
              if (
                p.num_protocollo != null &&
                !this.pCodici.includes(p.num_protocollo)
              ) {
                this.pCodici.push(p.num_protocollo);
              }
              if (
                p.num_documento != null &&
                !this.oCodici.includes(p.num_documento)
              ) {
                this.oCodici.push(p.num_documento);
              }
              if (
                p.ragione_sociale != null &&
                !this.ragioni_sociali.includes(p.ragione_sociale)
              ) {
                this.ragioni_sociali.push(p.ragione_sociale);
              }
              if (
                p.nom_utente != null &&
                !this.operatori.includes(p.nom_utente)
              ) {
                this.operatori.push(p.nom_utente);
              }
              p.stato_mag = p.stato_magazzino;
              p.stato_giacenza = p.stato_prelievo;
            }
            this.filtered = Array.from(res.data.documento);
            this.pCodici.sort((a, b) => (a < b ? -1 : a > b ? 1 : 0));
            this.pCodici.unshift("Tutti");
            this.oCodici.sort((a, b) => (a < b ? -1 : a > b ? 1 : 0));
            this.oCodici.unshift("Tutti");
            this.ragioni_sociali.sort((a, b) => (a < b ? -1 : a > b ? 1 : 0));
            this.ragioni_sociali.unshift("Tutti");
          } else {
            console.log(res);
            this.loading = false;
          }
        })
        .catch((err) => {
          if (err) {
            console.log(err);
          }
          this.loading = false;
        });

      if (this.selectedCod == "PLCG") {
        this.headers = Array.from(this.headers_placing);
      } else {
        this.headers = Array.from(this.headers_default);
      }
      console.log(this.selectedCod);
      console.log(this.headers);
      this.dtKey++;
      this.loading = false;
    },
    async callList() {
      if (
        localStorage.getItem("picking_selected_codice") != null &&
        localStorage.getItem("picking_selected_codice") != "" &&
        localStorage.getItem("picking_selected_codice") != "null"
      ) {
        this.selectedCod = localStorage.getItem("picking_selected_codice");
      }

      if (this.selectedCod == "PLCG") {
        this.headers = this.headers_placing;
      } else {
        this.headers = this.headers_default;
      }

      this.loading = true;

      await this.getMagazzini();
      await this.getImpostazioni();

      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getdocumento",
          token: localStorage.user_token,
          id_documento: "",
          cod_documento: this.selectedCod,
        },
      };

      await this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.pickings = new Array();
            this.pickings = Array.from(res.data.documento);
            for (let i = 0; i < this.pickings.length; i++) {
              const p = this.pickings[i];
              if (
                p.urgenza == null ||
                p.urgenza < 0 ||
                p.urgenza >= this.urgenze.length
              ) {
                p.urgenza = 0;
              }
              p.data_documento =
                p.data_documento.split("/")[2] +
                "-" +
                p.data_documento.split("/")[1] +
                "-" +
                p.data_documento.split("/")[0];
              if (
                p.num_protocollo != null &&
                !this.pCodici.includes(p.num_protocollo)
              ) {
                this.pCodici.push(p.num_protocollo);
              }
              if (
                p.ragione_sociale != null &&
                !this.ragioni_sociali.includes(p.ragione_sociale)
              ) {
                this.ragioni_sociali.push(p.ragione_sociale);
              }
              if (
                p.num_documento != null &&
                !this.oCodici.includes(p.num_documento)
              ) {
                this.oCodici.push(p.num_documento);
              }
              if (
                p.nom_utente != null &&
                !this.operatori.includes(p.nom_utente)
              ) {
                this.operatori.push(p.nom_utente);
              }
              p.stato_mag = p.stato_magazzino;
              p.stato_giacenza = p.stato_prelievo;
            }
            this.filtered = Array.from(res.data.documento);
            this.pCodici.sort((a, b) => (a < b ? -1 : a > b ? 1 : 0));
            this.pCodici.unshift("Tutti");
            this.oCodici.sort((a, b) => (a < b ? -1 : a > b ? 1 : 0));
            this.oCodici.unshift("Tutti");
            this.ragioni_sociali.sort((a, b) => (a < b ? -1 : a > b ? 1 : 0));
            this.ragioni_sociali.unshift("Tutti");
          } else {
            console.log(res);
            this.loading = false;
          }
        })
        .catch((err) => {
          if (err) {
            console.log(err);
          }
          this.loading = false;
        });

      this.loading = false;

      if (
        localStorage.getItem("picking_page") != "null" &&
        !isNaN(parseInt(localStorage.getItem("picking_page")))
      )
        this.pageNumber = parseInt(localStorage.getItem("picking_page"));
      console.log(this.pageNumber);
      if (localStorage.getItem("picking_filter_urgenza") != "null")
        this.filtro_urg = localStorage.getItem("picking_filter_urgenza");
      if (localStorage.getItem("picking_filter_statoMag") != "null")
        this.filtro_mag = JSON.parse(
          localStorage.getItem("picking_filter_statoMag")
        );
      if (localStorage.getItem("picking_filter_statoGiac") != "null")
        this.filtro_giac = JSON.parse(
          localStorage.getItem("picking_filter_statoGiac")
        );
      if (localStorage.getItem("picking_sort") != "null")
        this.pickingSortArr = JSON.parse(localStorage.getItem("picking_sort"));
      console.log(this.pickingSortArr);
      if (localStorage.getItem("picking_filter_show") != "null")
        this.show_filters =
          localStorage.getItem("picking_filter_show") == "true";
      if (localStorage.getItem("picking_filter_state") != "null")
        this.filtro_stato = JSON.parse(
          localStorage.getItem("picking_filter_state")
        );
      if (localStorage.getItem("picking_filter_picking") != "null")
        this.filtro_picking = localStorage.getItem("picking_filter_picking");
      if (localStorage.getItem("picking_filter_operator") != "null")
        this.filtro_operatore = localStorage.getItem("picking_filter_operator");
      if (localStorage.getItem("picking_filter_order") != "null")
        this.filtro_ordine = localStorage.getItem("picking_filter_order");
      if (localStorage.getItem("picking_filter_date_start") != "null")
        this.data_start_formatted = localStorage.getItem(
          "picking_filter_date_start"
        );
      if (localStorage.getItem("picking_filter_date_end") != "null")
        this.data_end_formatted = localStorage.getItem(
          "picking_filter_date_end"
        );
      this.changeFilters();

      if (this.selectedCod == "PLCG") {
        this.headers = Array.from(this.headers_placing);
      } else {
        this.headers = Array.from(this.headers_default);
      }
      console.log(this.selectedCod);
      console.log(this.headers);
      this.dtKey++;
    },
    getTipologia(id_tabella) {
      if (!this.tipologie.length) {
        return "";
      }

      const tipo = this.tipologie.find((el) => el.id_tabella == id_tabella);
      return tipo ? tipo.des : "";
    },
    /*avviaPicking(item) {
      let request = {
        controller: "Picking",
        method: "PUT",
        richiesta: {
          action: "",
          token: localStorage.user_token,
          ...item,
        },
      };

      this.$store.dispatch("api", request).then(async (res) => {
        if (res.status == 200) {
          this.$refs.SnackbarQV.print(
            "success",
            'Picking avviata con successo.'
          );
        }
      });
    },*/
    showDeletePicking() {
      this.dialogEliminaPicking = true;
    },
    deletePicking() {
      this.dialogEliminaPicking = false;
    },
    toggleFilters() {
      this.show_filters = !this.show_filters;
    },
    changeFilters() {
      this.filtered = this.pickings.filter(
        (item) =>
          (this.filtro_ordine == null ||
            this.filtro_ordine == "" ||
            item.num_documento == this.filtro_ordine ||
            this.filtro_ordine == "Tutti") &&
          (this.filtro_urg == null ||
            item.urgenza == this.filtro_urg ||
            this.filtro_urg == -1) &&
          (this.filtro_mag == null ||
            this.filtro_mag.text == "" ||
            item.stato_mag == this.filtro_mag.value ||
            this.filtro_mag.text == "Tutti") &&
          (this.filtro_rag_soc == null ||
            this.filtro_rag_soc == "" ||
            item.ragione_sociale == this.filtro_rag_soc ||
            this.filtro_rag_soc == "Tutti") &&
          (this.filtro_picking == null ||
            this.filtro_picking == "" ||
            item.num_protocollo == this.filtro_picking ||
            this.filtro_picking == "Tutti") &&
          (this.filtro_operatore == null ||
            this.filtro_operatore == "" ||
            item.nom_utente == this.filtro_operatore ||
            this.filtro_operatore == "Tutti") &&
          (this.filtro_stato == null ||
            this.filtro_stato.text == "" ||
            this.filtro_stato.vals.includes(item.stato_doc) ||
            this.filtro_stato.text == "Tutti") &&
          (this.filtro_giac == null ||
            item.stato_giacenza == this.filtro_giac.value ||
            this.filtro_giac.text == "" ||
            this.filtro_giac.text == "Tutti") &&
          (this.data_start_formatted == null ||
            this.data_start_formatted == "" ||
            Date.parse(item.data_documento) >=
              Date.parse(this.data_start_formatted)) &&
          (this.data_end_formatted == null ||
            this.data_end_formatted == "" ||
            Date.parse(item.data_documento) <=
              Date.parse(this.data_end_formatted))
      );
    },
    changeDate() {
      if (this.data_start != null) {
        this.data_start_formatted = this.data_start.toString();
      }
      if (this.data_end != null) {
        this.data_end_formatted = this.data_end.toString();
      }
      this.changeFilters();
      this.menu_da = false;
      this.menu_a = false;
    },
    clearEnd() {
      this.data_end_formatted = null;
      this.data_end = null;
      this.changeFilters();
    },
    clearStart() {
      this.data_start_formatted = null;
      this.data_start = null;
      this.changeFilters();
    },
  },
};
</script>